BaseModel = require './base_model.coffee'

class global.User extends BaseModel
  @ATTRIBUTES = {
    id: {}
    name: {}
    email: {}
    role: {}
    human_role: {}
    authentication_token: {}
    picture_url: {}
    signature: {}
    timezone: {}
    pipedrive_api_key: {}
    rd_station_crm_api_key: {}
    cv_crm_api_token: {}
    nectar_api_key: {}
    email_authorized: {}
    email_service_requires_authorization: {}
    email_account_status: {}
    can_manage_templates: {}
    can_see_all_contacts: {}
    plivo_endpoint: {}
    api_token: {}
    virtual_user_count: {}
    nylas_setting: {}
    email_service: {}
    created_at: {}
    company_id: {}
    new_ui: { default: false }
    extradata: { default: {} },
    default_user: {}
  }

  @ASSOCIATIONS = {
    company: -> Company
    salesforce_setting: -> SalesforceSetting
    rd_station_setting: -> RdStationSetting
    pipedrive_setting: -> PipedriveSetting
    rd_station_crm_setting: -> RDStationCRMSetting
    crm_setting: -> CRMSetting
    nectar_setting: -> NectarSetting
    webhook_setting: -> WebhookSetting
    vtiger_setting: -> VtigerSetting
    hubspot_setting: -> HubspotSetting
    sharpspring_setting: -> SharpspringSetting
    leadlovers_setting: -> LeadloversSetting
    cv_crm_setting: -> CvCrmSetting
    flow: -> Flow
  }

  @ROLES = { admin: 0, manager: 1, seller: 2, monitoring_manager: 3, sdr: 4 }

  @SERIALIZABLE_ASSOCIATIONS = [
    'salesforce_setting',
    'rd_station_setting',
    'rd_station_crm_setting',
    'crm_setting',
    'pipedrive_setting',
    'nectar_setting',
    'vtiger_setting',
    'hubspot_setting',
    'webhook_setting',
    'sharpspring_setting',
    'leadlovers_setting',
    'cv_crm_setting'
  ]

  firstAndLastName: ->
    [first, ..., last] = @name.split(' ')
    if first != last
      first + ' ' + last
    else
      first

  firstName: ->
    @name.split(' ')[0]

  isAdmin: ->
    @role == 'admin'

  isSeller: ->
    @role == 'seller' || @role == 'sdr'

  isManager: ->
    @role == 'manager'

  isMonitoringManager: ->
    @role == 'monitoring_manager'

  requireEmailAuthorization: ->
    @email_service_requires_authorization && !@email_authorized

  requireEmailReauthorization: ->
    @email_account_status && @email_account_status != 'running'

  manager_and_not_owner: (object) ->
    @isManager() && @id != object.user.id

  hasMoreAccounts: ->
    @virtual_user_count > 1

  isSparkpost: ->
    @email_service == 'sparkpost'

  isNylas: ->
    @email_service == 'nylas'

  roleDescription: ->
    return 'SDR' if @role == 'sdr'
    return 'Executivo de vendas' if @role == 'seller'
    return 'Gerente de acompanhamento' if @role == 'monitoring_manager'
    return 'Gerente de contas' if @role == 'manager'
    ''

  selectedLanguage: ->
    return @extradata['language'] || 'pt-BR'



// WEBPACK FOOTER //
// ./src/models/user.coffee